module.exports = __webpack_public_path__ + "1899a60ba32cecec3bb5b74156956749.png";